import { supabase } from '@/integrations/supabase/client';

export interface ExternalTool {
  id: string;
  user_id: string;
  tool_name: string;
  category: string | null;
  rating: number | null;
  status: 'owned' | 'tried';
  notes: string | null;
  created_at: string;
  updated_at: string;
}

/**
 * Get user's external tools (tools not in marketplace)
 */
export async function getExternalTools(userId: string): Promise<ExternalTool[]> {
  const { data, error } = await supabase
    .from('agent_external_tools')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return (data || []) as ExternalTool[];
}

/**
 * Add external tool to agent's stack
 */
export async function addExternalTool(params: {
  userId: string;
  toolName: string;
  category?: string;
  rating?: number;
  status?: 'owned' | 'tried';
  notes?: string;
}) {
  const { data, error } = await supabase
    .from('agent_external_tools')
    .insert({
      user_id: params.userId,
      tool_name: params.toolName,
      category: params.category || null,
      rating: params.rating || null,
      status: params.status || 'owned',
      notes: params.notes || null,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

/**
 * Update external tool
 */
export async function updateExternalTool(
  toolId: string,
  updates: {
    tool_name?: string;
    category?: string;
    rating?: number;
    status?: 'owned' | 'tried';
    notes?: string;
  }
) {
  const { data, error } = await supabase
    .from('agent_external_tools')
    .update(updates)
    .eq('id', toolId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

/**
 * Remove external tool
 */
export async function removeExternalTool(toolId: string) {
  const { error } = await supabase
    .from('agent_external_tools')
    .delete()
    .eq('id', toolId);

  if (error) throw error;
}
